import React from 'react';
import DetailItem from './DetailItem';
import OriginalSize from './OriginalSize';
import { deviationHasFileSizeMetadata } from './helpers';
export const DetailItemList = ({ deviation })=>{
    var _deviation_extended;
    var _deviation_extended_exif;
    const exif = (_deviation_extended_exif = deviation === null || deviation === void 0 ? void 0 : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.exif) !== null && _deviation_extended_exif !== void 0 ? _deviation_extended_exif : [];
    const hasDetails = exif.length > 0 || deviationHasFileSizeMetadata(deviation);
    if (!hasDetails) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(OriginalSize, {
        deviation: deviation
    }), exif.map(({ tag, value })=>/*#__PURE__*/ React.createElement(DetailItem, {
            key: tag,
            name: tag,
            value: value,
            transPrefix: "exif."
        })));
};
DetailItemList.displayName = 'DetailItemList';
export default DetailItemList;

//# sourceMappingURL=DetailItemList.js.map